@if (fieldSet.includes(ServiceDataFields.DueDate)) {
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="expectedConfinementDate">{{
            'serviceData.form.expectedConfinementDate' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            ngbDatepicker
            class="form-control"
            formControlName="expectedConfinementDate"
            id="expectedConfinementDate"
            appInputValidationStatus
            container="body"
            #confinementDatepicker="ngbDatepicker"
            [attr.data-cy]="ServiceDataFields.DueDate + '-input'"
            [minDate]="momentToNgbDate(minDate)"
            [maxDate]="momentToNgbDate(maxDate)"
            [startDate]="momentToNgbDate(startDate)"
            [placeholder]="
              'serviceData.form.placeholders.dateFormat' | translate
            "
            (click)="confinementDatepicker.toggle()"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="expectedConfinementDate"
            translations="validation.generic"
            [attr.data-cy]="ServiceDataFields.DueDate + '-validation-error'"
          ></app-validation-error>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center" formGroupName="gestationAge">
        <div class="col-12 col-sm-4 mb-1">
          <label>{{ 'serviceData.form.gestationAge' | translate }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <div class="row m-0">
            <div class="col-6 ps-0">
              <input
                class="form-control"
                type="number"
                formControlName="week"
                id="gestationWeek"
                appInputValidationStatus
                data-cy="GestationAgeWeek-input"
                [placeholder]="
                  'serviceData.form.placeholders.gestationWeek' | translate
                "
                [readonly]="
                  form.get('isGestationAgeAutomaticallyCalculated').value
                "
              />
            </div>
            <div class="col-6 pe-0">
              <input
                class="form-control"
                type="number"
                formControlName="day"
                id="gestationDay"
                appInputValidationStatus
                data-cy="GestationAgeDay-input"
                [placeholder]="
                  'serviceData.form.placeholders.gestationDay' | translate
                "
                [readonly]="
                  form.get('isGestationAgeAutomaticallyCalculated').value
                "
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-end p-0 m-0">
          <div class="col-6 col-sm-4">
            <app-validation-error
              for="week"
              translations="serviceData.form.validation.vtsGestationAge"
              data-cy="GestationAgeWeek-validation-error"
            ></app-validation-error>
          </div>
          <div class="col-6 col-sm-4">
            <app-validation-error
              for="day"
              translations="validation.generic"
              data-cy="GestationAgeDay-validation-error"
            ></app-validation-error>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12 col-sm-8 offset-sm-4">
          <div class="form-check form-check-lg">
            <input
              class="form-check-input me-2"
              type="checkbox"
              formControlName="isGestationAgeAutomaticallyCalculated"
              data-cy="IsGestationAgeAutomaticallyCalculated-checkbox"
            />
            <label class="form-check-label">
              {{ 'serviceData.form.autoCalculate' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
}
